var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"molecule-google-map",class:{
    'universe-map-container': _vm.isUniversePage
  },style:({ width: _vm.canvasWidth })},[(_vm.isUniversePage)?_c('div',{staticClass:"overlay-white"}):_vm._e(),_vm._v(" "),_c('div',{ref:"map",staticClass:"google-map",attrs:{"data-marker-id":_vm.activeCenterMarkerId}})])
}
var staticRenderFns = []

export { render, staticRenderFns }